import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const benefits = ['Eliminate manual reporting errors completely', 'Ensure 100% compliance with KRA regulations', 'Save valuable hours for strategic growth', 'Experience peace of mind with automated syncing', 'Premium support dedicated to your success'];
export function Benefits() {
  return <section className="py-32 bg-sovereign-navy-light overflow-hidden border-y border-white/5" data-id="element-25">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-26">
        <div className="flex flex-col lg:flex-row items-center gap-20" data-id="element-27">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:w-1/2" data-id="element-28">
            <span className="text-sovereign-gold uppercase tracking-widest text-sm font-medium mb-4 block" data-id="element-29">
              Why Choose Sovereign
            </span>
            <h2 className="text-4xl md:text-6xl font-serif text-white mb-8 leading-tight" data-id="element-30">
              Elevate Your <br data-id="element-31" />
              <span className="italic text-sovereign-gold" data-id="element-32">
                Business Standards
              </span>
            </h2>
            <p className="text-gray-400 text-lg mb-10 font-light leading-relaxed" data-id="element-33">
              In a world of complexity, simplicity is the ultimate luxury.
              Sovereign eTims removes the burden of tax compliance, allowing you
              to focus on what truly matters: building your legacy.
            </p>

            <ul className="space-y-6" data-id="element-34">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-35">
                  <div className="mt-1 flex-shrink-0 w-5 h-5 rounded-full border border-sovereign-gold flex items-center justify-center" data-id="element-36">
                    <Check className="w-3 h-3 text-sovereign-gold" data-id="element-37" />
                  </div>
                  <span className="text-gray-300 font-medium" data-id="element-38">{benefit}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* Visual Element */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="lg:w-1/2 relative" data-id="element-39">
            <div className="relative aspect-square md:aspect-[4/3] bg-sovereign-navy p-12 flex items-center justify-center overflow-hidden border border-sovereign-gold/20" data-id="element-40">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-sovereign-navy-light via-sovereign-navy to-sovereign-navy opacity-50" data-id="element-41" />

              {/* Abstract decorative elements */}
              <div className="absolute top-0 right-0 w-64 h-64 border border-sovereign-gold/20 rounded-full translate-x-1/3 -translate-y-1/3" data-id="element-42" />
              <div className="absolute bottom-0 left-0 w-96 h-96 border border-sovereign-gold/10 rounded-full -translate-x-1/3 translate-y-1/3" data-id="element-43" />

              <div className="relative z-10 text-center" data-id="element-44">
                <div className="text-sovereign-gold text-6xl font-serif mb-2" data-id="element-45">
                  100%
                </div>
                <div className="text-white text-sm tracking-[0.3em] uppercase" data-id="element-46">
                  Compliance Rate
                </div>
              </div>
            </div>

            {/* Gold accent border */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-sovereign-gold/30 -z-10" data-id="element-47" />
          </motion.div>
        </div>
      </div>
    </section>;
}